<template>
  <div class="dataInfoRoot">
    <div class="linkInfoPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />

      <div v-else class="linkInfoPage__layout resourceFormPage__layout">
        <div class="resourceFormPage__headerDock">
          <header class="resourceFormPage__actionBar">
            <div class="resourceFormPage__lead">
              <h1 class="resourceFormPage__pageTitle">查看数据集</h1>
            </div>
            <div class="resourceFormPage__actions">
              <button
                v-if="Number(ruleForm.status) === 2"
                type="button"
                class="resourceFormPage__btn dataInfoActionBtn dataInfoActionBtn--online"
                v-check-role
                @click="liveOrOff"
              >
                上线
              </button>
              <button
                v-else
                type="button"
                class="resourceFormPage__btn dataInfoActionBtn dataInfoActionBtn--offline"
                v-check-role
                @click="liveOrOff"
              >
                下线
              </button>
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--primary"
                v-check-role
                @click="goEdit"
              >
                编辑
              </button>
            </div>
          </header>
        </div>

        <main class="linkInfoPage__main resourceFormPage__main main dataFormPage__main">
          <el-card class="card linkInfoSection">
            <div slot="header" class="dataInfoSection__header">
              <strong class="linkInfoSection__title">数据集基本信息</strong>
              <span
                v-if="ruleForm.status !== '' && ruleForm.status != null"
                class="statusPill"
                :class="'statusPill--' + getDatasetStatusPillVariant(ruleForm.status)"
              >
                <span class="statusPill__dot" aria-hidden="true" />
                {{ getDatasetStatusLabel(ruleForm.status) }}
              </span>
            </div>
            <div class="dataInfoBasic__metaRow dataInfoBasic__metaRow--three">
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">数据集名称</span>
                <span class="dataInfoBasic__name">{{ ruleForm.name || '—' }}</span>
              </div>
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">key</span>
                <code class="linkInfoBasic__fieldValue link-font-mono">{{ ruleForm.key || '—' }}</code>
              </div>
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">关联应用</span>
                <span class="linkInfoBasic__fieldValue">{{ appLabel }}</span>
              </div>
            </div>
          </el-card>

          <el-card class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">过滤条件</strong>
            </div>
            <dl class="dataInfoFilter">
              <div class="dataInfoFilter__item">
                <dt class="dataInfoFilter__label">国家</dt>
                <dd
                  class="dataInfoFilter__value"
                  :class="{ 'dataInfoFilter__value--muted': countryReadonly === '未配置' }"
                >
                  {{ countryReadonly }}
                </dd>
              </div>
              <div class="dataInfoFilter__item">
                <dt class="dataInfoFilter__label">系统版本</dt>
                <dd
                  class="dataInfoFilter__value"
                  :class="{ 'dataInfoFilter__value--muted': apiVersionReadonly === '未配置' }"
                >
                  {{ apiVersionReadonly }}
                </dd>
              </div>
              <div class="dataInfoFilter__item">
                <dt class="dataInfoFilter__label">应用版本</dt>
                <dd
                  class="dataInfoFilter__value"
                  :class="{ 'dataInfoFilter__value--muted': appVersionReadonly === '未配置' }"
                >
                  {{ appVersionReadonly }}
                </dd>
              </div>
            </dl>
          </el-card>

          <el-card class="card linkInfoSection">
            <div slot="header" class="dataRelationSection__header">
              <div class="dataRelationSection__headerMain">
                <strong class="linkInfoSection__title">数据关联</strong>
                <span v-if="relationList.length" class="dataRelationSection__count">
                  共 {{ relationList.length }} 项
                </span>
              </div>
            </div>
            <div v-if="relationList.length" class="dataRelationReadonly">
              <div class="dataRelationReadonly__head">
                <span class="dataRelationReadonly__col dataRelationReadonly__col--index">#</span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--name">字段名</span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--page">关联页面</span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--status">发布状态</span>
              </div>
              <div
                v-for="(item, index) in relationList"
                :key="item.id"
                class="dataRelationReadonly__row"
              >
                <span class="dataRelationReadonly__col dataRelationReadonly__col--index">
                  {{ index + 1 }}
                </span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--name">
                  <span class="dataRelationReadonly__name" :title="item.name">{{ item.name }}</span>
                </span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--page">
                  <span class="dataRelationReadonly__page">
                    {{ resolvePageName(pageOptions, item.pageId) }}
                  </span>
                </span>
                <span class="dataRelationReadonly__col dataRelationReadonly__col--status">
                  <span
                    class="statusPill statusPill--relation"
                    :class="'statusPill--' + (item.isOnLive ? 'online' : 'offline')"
                  >
                    <span class="statusPill__dot" aria-hidden="true" />
                    {{ item.isOnLive ? '上线' : '下线' }}
                  </span>
                </span>
              </div>
            </div>
            <p v-else class="dataInfoEmpty">—</p>
          </el-card>

          <el-card v-if="ruleForm.remarks" class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">备注</strong>
            </div>
            <p class="dataInfoComment">{{ ruleForm.remarks }}</p>
          </el-card>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import {
  dataOnOrOff,
  getaAllRelationApp,
  getAllPage,
  getDataById,
} from '../../../api/dataManage'
import {
  createEmptyDataRuleForm,
  mapDataDetailToForm,
  parseDataRelationList,
} from './dataFormConstants'
import {
  buildCountryFilterReadonly,
  buildVersionFilterReadonly,
  resolveAppLabel,
  resolvePageName,
} from './dataInfoHelper'
import {
  getDatasetStatusLabel,
  getDatasetStatusPillVariant,
} from './dataListHelpers'

export default {
  name: 'DataManageInfo',
  data() {
    return {
      ruleForm: createEmptyDataRuleForm(),
      relationList: [],
      appOptions: [],
      pageOptions: [],
      loading: false,
    }
  },
  computed: {
    appLabel() {
      return resolveAppLabel(this.appOptions, this.ruleForm.relationApp)
    },
    countryReadonly() {
      return buildCountryFilterReadonly(this.ruleForm.country)
    },
    apiVersionReadonly() {
      return buildVersionFilterReadonly(this.ruleForm.apiVersion)
    },
    appVersionReadonly() {
      return buildVersionFilterReadonly(this.ruleForm.appVersion)
    },
  },
  created() {
    this.loadAppOptions()
    this.loadPageOptions()
    this.loadDataDetail()
  },
  methods: {
    getDatasetStatusLabel,
    getDatasetStatusPillVariant,
    resolvePageName,
    loadAppOptions() {
      getaAllRelationApp().then((res) => {
        if (res.success) {
          this.appOptions = res.data || []
        }
      })
    },
    loadPageOptions() {
      getAllPage().then((res) => {
        if (res.success) {
          this.pageOptions = res.data || []
        }
      })
    },
    loadDataDetail() {
      this.loading = true
      getDataById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm = mapDataDetailToForm(res.data)
            this.relationList = parseDataRelationList(res.data.dataRelation)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    liveOrOff() {
      const nextLabel = Number(this.ruleForm.status) === 2 ? '上线' : '下线'
      this.$confirm(`是否确认将状态改成：${nextLabel}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => dataOnOrOff({ id: this.$route.params.id }))
        .then((res) => {
          if (res && res.success) {
            this.$message.success('修改成功')
            this.$router.push('/channel/data/list')
          }
        })
        .catch((error) => {
          if (error !== 'cancel') return
          this.$message.info('已取消修改')
        })
    },
    goEdit() {
      this.$router.push(`/channel/data/edit/${this.$route.params.id}`)
    },
  },
}
</script>

<style scoped>
.dataInfoRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__lead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  min-width: 0;
  flex: 1;
}

.resourceFormPage__actions .resourceFormPage__btn {
  box-sizing: border-box;
  min-width: 104px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>

<style>
.collectionModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.collectionModule .main {
  background: transparent;
}
</style>
